import React from 'react';
import './bootcamp.css';
import DiveDeeper from '../../../../img/bootcamp/DiveDeeper.png'

const b_deeper = () => {return (
        <div className="m_wywl__wrap b_wywl__wrap">
            <div className="m_wywl container">
                <h3 className="b_why--title">Dive Deeper</h3>
                <p className='b_why--undertitle'>Get hands-on experience in job-ready skills</p>
                <div className="b_deeper--img_block">
                    <img className="b_deeper--img" src={DiveDeeper} alt="" />
                </div>
            </div>
        </div>
    );
};

export default b_deeper;